import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

const getSubscriptionCommitmentText = ({commitmentMonthlyOptions, defaultCommitmentMonths, i18n}) => {
  const filteredCommitmentPeriods = commitmentMonthlyOptions.filter(value => value !== defaultCommitmentMonths)

  const commitmentsText = filteredCommitmentPeriods.reduce((commitmentLiteral, currentValue, index) => {
    let currentLiteral = currentValue

    if (currentValue === 0) {
      currentLiteral = i18n.t('COMMON.NO_COMMITMENT')
    }

    if (index === filteredCommitmentPeriods.length - 1 && currentValue !== 0) {
      currentLiteral = i18n.t('COMMON_N_MONTHS', currentValue)
    }

    if (index < filteredCommitmentPeriods.length - 2) return `${commitmentLiteral}${currentLiteral}, `

    if (index < filteredCommitmentPeriods.length - 1)
      return `${commitmentLiteral}${currentLiteral} ${i18n.t('COMMON.AND')} `

    return `${commitmentLiteral}${currentLiteral}`
  }, '')
  return commitmentsText
}

const CardAdFooterSubscription = ({ad}) => {
  const {i18n} = useContext(Context)
  const {commitmentMonthlyOptions = [], kmIncluded, kmIncludedPeriod, monthlySubscriptionCommitment} = ad

  const defaultCommitmentMonths = monthlySubscriptionCommitment

  const literalOtherOptions = ` · ${i18n.t('COMMON.ALSO_AVAILABLE_FOR')}: ${getSubscriptionCommitmentText({
    i18n,
    commitmentMonthlyOptions,
    defaultCommitmentMonths
  })}`

  const hasMoreThanOneCommitmentOption = commitmentMonthlyOptions.length > 1

  const showLiteralOtherOptions = hasMoreThanOneCommitmentOption

  const hasKmIncluded = Boolean(kmIncluded)
  const literalKms = hasKmIncluded
    ? ` · ${i18n.t('COMMON.KMS_INCLUDED')}: ${i18n.n(kmIncluded)} ${i18n.t(`COMMON.PERIOD.${kmIncludedPeriod}`)}`
    : ''

  return (
    <div className="mt-CardAd-footerFinancingInfoContainer">
      {`* ${i18n.t('COMMON.COMMITMENT')}: ${
        defaultCommitmentMonths ? i18n.t('COMMON_N_MONTHS', defaultCommitmentMonths) : i18n.t('COMMON.COMMITMENT_NONE')
      }${literalKms}${showLiteralOtherOptions ? literalOtherOptions : ''}`}
    </div>
  )
}

CardAdFooterSubscription.displayName = 'CardAdFooterSubscription'

CardAdFooterSubscription.propTypes = {
  ad: PropTypes.object
}

export default CardAdFooterSubscription
